import { useEffect, type ReactNode } from 'react'
import { useAuthStore } from '../../stores/useAuthStore.js'
import { usePostMessage } from '../../hooks/usePostMessage.js'
import { apiFetch } from '../../lib/api-client.js'
import type { UserProfile } from '../../types/user.js'
import { AuthLoading } from './AuthLoading.js'
import { AuthError } from './AuthError.js'

interface AuthGuardProps {
  children: ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  usePostMessage()

  const tokens = useAuthStore((s) => s.tokens)
  const user = useAuthStore((s) => s.user)
  const isLoading = useAuthStore((s) => s.isLoading)
  const error = useAuthStore((s) => s.error)
  const setUser = useAuthStore((s) => s.setUser)
  const setError = useAuthStore((s) => s.setError)

  useEffect(() => {
    if (!tokens) return

    apiFetch<UserProfile>('/api/auth/validate')
      .then(setUser)
      .catch((err) => setError(err instanceof Error ? err.message : 'Erro na autenticação'))
  }, [tokens, setUser, setError])

  if (error) return <AuthError message={error} />
  if (!tokens) return <AuthLoading message="Aguardando autenticação..." />
  if (isLoading || !user) return <AuthLoading />

  return <>{children}</>
}
